<template>
  <div class="row" :key="Render" v-if="ListRq.length > 0">
    <div class="col-md-6 col-12" v-for="(item, key) in ListRq" :key="key" @click="OpenList(item)">
      <Card id="RowCard" v-if="item.length > 0">
        <template v-slot:content>
          <div class="row Pointer">
            <div class="col-10">
              <p class="text-logo">{{ item[0].formName }}</p>
              <small class="d-block"
                >شما
                <h5 class="d-inline mx-2 text-logo">{{ item.length }}</h5>
                درخواست دارید</small
              >
            </div>
            <div class="col-2" style="position: relative">
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 1" class="Position fad fa-suitcase-rolling text-logo fa-3x"></i>
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 2" class="Position fad fa-user-clock text-logo fa-3x"></i>
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 3" class="Position fad fa-plane-alt text-logo fa-3x"></i>
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 4" class="Position fad fa-shopping-basket text-logo fa-3x"></i>
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 5" class="Position fad fa-money-check-edit-alt text-logo fa-3x"></i>
              <i v-if="item.length > 0 && item[0].tblFormAutomationId == 6" class="Position fad fa-coins text-logo fa-3x"></i>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'

export default {
  data() {
    return {
      ListRq: [],
      Render:0
    }
  },
  components: { Card },
  created() {
    // setInterval(this.myCallbackInterval(), 1000)
    this.myCallbackInterval()
  },
  methods: {
    myCallbackInterval() {
      var AxiosGet = { ArryfildValue: '', Method: 'Get', Action: 'ListProcessWorkFlow', Token: this.$session.get('Token') }
      this.$GetData_Body(AxiosGet).then((res) => {
        if (res.status == 'Success') {
          this.ListRq = []
          let A1 = []
          let A2 = []
          let A3 = []
          let A4 = []
          let A5 = []
          let A6 = []
          res.data.forEach((e) => {
            switch (e.tblFormAutomationId) {
              case 1:
                A1.push(e)
                break
              case 2:
                A2.push(e)
                break
              case 3:
                A3.push(e)
                break
              case 4:
                A4.push(e)
                break
              case 5:
                A5.push(e)
                break
              case 6:
                A6.push(e)
                break
              default:
                break
            }
          })
          // console.log(A1)
          // console.log(A2)
          // console.log(A3)
          // console.log(A4)
          // console.log(A5)
          if (A1.length > 0) {
            this.ListRq.push(A1)
          }
          if (A2.length > 0) {
            this.ListRq.push(A2)
          }
          if (A3.length > 0) {
            this.ListRq.push(A3)
          }
          if (A4.length > 0) {
            this.ListRq.push(A4)
          }
          if (A5.length > 0) {
            this.ListRq.push(A5)
          }
          if (A6.length > 0) {
            this.ListRq.push(A6)
          }
        }

      })
      this.Render++
    },
    OpenList(list) {
      this.$router.push({name:'ListProcessWorkFlow', params:{tblformAutomationId:list[0].tblFormAutomationId}})
    },
  },
}
</script>
<style>
.Position {
  position: absolute;
  top: 0;
  left: -20px;
}
#RowCard:hover i {
  transform: rotate(-30deg);
  font-size: 56px !important;
  transition: 0.5s;
}
#RowCard i {
  transition: 0.5s;
}
</style>
